export class SubriderRecord {
  id: number = 0;
  vpoolid: number = 0;
  vpname: string = "";
  hours: string = "";
  univId: string = "";
  userId: number = 0;
  first_name: string = "";
  last_name: string = "";
  hawkid: string = "";
  status: string = "";
  position: number = 0;
  start_date: Date = new Date(0);
  end_date: Date = new Date(0);
  comment: string = "";
}